import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../hooks/use-auth";

const DEFAULT_ERROR = {
  errEmail: "",
  isValid: false,
  isClicked: false,
};

const useHandler = () => {
  const { requestPasswordReset } = useAuth();
  const navigete = useNavigate();
  const [searchParams] = useSearchParams();
  const isForgot = searchParams.get("isForgot");
  const [email, setEmail] = useState();
  const [error, setError] = useState(DEFAULT_ERROR);
  const [isLoading, setIsLoading] = useState(false); // NEW
  const isEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

  const { isClicked } = error;

  const onValidate = useCallback(() => {
    let errState = { ...DEFAULT_ERROR, isValid: true, isClicked: true };

    if (!isEmail.test(email)) {
      errState = {
        ...errState,
        errEmail: "Please enter a valid email",
        isValid: false,
      };
    }

    setError(errState);
    return errState;
  }, [email]);

  useEffect(() => {
    if (isClicked) onValidate();
  }, [email, isClicked, onValidate]);

  const onResetPassword = async () => {
    if (!email || !isEmail.test(email)) {
      setError((prev) => ({
        ...prev,
        errEmail: "Please enter a valid email to reset password",
        isClicked: true,
      }));
      return;
    }

    if (isLoading) return; // guard against double-clicks

    try {
      setIsLoading(true);
      await requestPasswordReset(email);
    } catch (err) {
      setError((prev) => ({
        ...prev,
        errEmail: "Something went wrong. Please try again.",
      }));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    navigete,
    setEmail,
    onResetPassword,
    isForgot,
    email,
    error,
    isLoading, // NEW
  };
};

export default useHandler;
